import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the casino report view.
 * @extends JetView
 */
export default class tableCasinoReportView extends JetView {
    /**
     * Configures the UI components of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        var vthis = this; // Reference to the current instance
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        /**
         * Formats a value as a percentage.
         * @param {number} value - The value to format.
         * @returns {string} The formatted percentage string.
         */
        function percentFormat(value) {
            return webix.i18n.numberFormat(value) + '%'; // Formatting value as percentage
        }

        // Extending the summTreeColumn data filter
        webix.ui.datafilter.summTreeColumn = webix.extend(
            {
                /**
                 * Refreshes the filter display with the calculated sum.
                 * @param {Object} master - The master data table.
                 * @param {Object} node - The node to update.
                 * @param {Object} value - The value containing columnId.
                 */
                refresh: function (master, node, value) {
                    var result = 0; // Variable to hold the sum result
                    var resultFormat = 0; // Variable to hold formatted result
                    master.data.each(function (obj) {
                        if (obj.$level == 1) {
                            // Check if the level is 1
                            result += obj[value.columnId]; // Accumulate the sum
                        }
                    });
                    // Formatting the result based on the columnId
                    if (value.columnId === 'CantidadTickets') {
                        resultFormat = webix.i18n.intFormat(result);
                    } else {
                        if (value.columnId === 'Profitness') {
                            resultFormat = webix.i18n.numberFormat(result) + '%';
                        } else {
                            resultFormat = webix.i18n.priceFormat(result);
                        }
                    }
                    node.firstChild.innerHTML = resultFormat; // Update the node with formatted result
                },
            },
            webix.ui.datafilter.summColumn, // Extending from summColumn
        );

        // Returning the main layout configuration
        return {
            rows: [
                {
                    cols: [
                        {
                            type: 'wide',
                            view: 'datatable', // Data table for displaying data
                            id: 'datatable', // Unique ID for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            height: 0, // Initial height
                            autoConfig: true, // Automatically configure columns
                            columns: [], // Columns configuration
                            onClick: {
                                /**
                                 * Handles click event on details.
                                 * @param {Event} euv - The event object.
                                 * @param {string} id - The ID of the clicked item.
                                 */
                                details: function (euv, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
                                    // Show details in a responsive manner
                                    if (screen.width < 500 || screen.height < 500) {
                                        $$('windowDetailsCasino').show();
                                    } else {
                                        $$('dColl').expand();
                                        $$('formDetails').clear();
                                        $$('a5').scrollTo(
                                            0,
                                            $$('formDetails').$height + $$('datatable').$height / 2 + 55,
                                        );
                                    }
                                },
                                /**
                                 * Handles click event on user.
                                 * @param {Event} euv - The event object.
                                 * @param {string} id - The ID of the clicked item.
                                 */
                                user: function (euv, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    this.$scope.app.callEvent('popupUserIframe', [item.Username]); // Trigger popup user iframe event
                                },
                            },
                        },
                        {
                            type: 'wide',
                            scrollY: true, // Enable vertical scrolling
                            height: 0, // Initial height
                            view: 'treetable', // Tree table for hierarchical data
                            id: 'datatable2', // Unique ID for the tree table
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            columns: [], // Columns configuration
                            autoConfig: true, // Automatically configure columns
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The main data grid.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Reference to the main data grid
        var grid2 = $$('datatable2'); // Reference to the secondary data grid
        var datata = $$('datata'); // Reference to another data variable
        var url = devConfig.geturlApi() + 'null/Report/GetCasinoGamesReport2'; // API URL for fetching report data
        var url2 = devConfig.geturlApi() + 'null/Report/GetCasinoGamesReport2'; // Duplicate URL for another purpose
        var flag = false; // Flag for export status
        var vthis = this; // Reference to the current instance
        grid.hide(); // Hide the main grid initially
        $$('toolbar1').hide(); // Hide the first toolbar
        var filter = ''; // Initialize filter variable

        // Event listener for filtering the casino report
        this.on(this.app, 'casinoReport:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string
            var providergroup = 0; // Provider group flag
            for (var i = 0; i < object.length; i++) {
                if (object[i][0] == 'Type') {
                    if (object[i][1] == 'D') {
                    } else {
                        providergroup = 1; // Set provider group if not 'D'
                    }
                }
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Append to query string
                } else {
                    if (typeof object[i][1] === 'object') {
                        if (object[i][0] === 'Date') {
                            var d = new Date(object[i][1]); // Create date object
                            var dateFrom =
                                'DateFrom=' +
                                d.getFullYear() +
                                '-' +
                                ('00' + (d.getMonth() + 1)).slice(-2) +
                                '-' +
                                '01'; // Format date for query
                            string1 = string1 + '&' + dateFrom; // Append date to query string
                        }
                    }
                }
            }
            if (providergroup == 0) {
                grid.show(); // Show the main grid
                grid2.hide(); // Hide the secondary grid
                grid.clearAll(); // Clear previous data
                string1 = string1 + '&Report=1'; // Append report flag to query
                webix
                    .ajax()
                    .headers({
                        'Content-type': 'application/json', // Set content type for AJAX request
                    })
                    .get(devConfig.geturlApi() + 'Financial/GetControlFiscal?' + string1, {
                        success: function (text, data, XmlHttpRequest) {
                            var resp = JSON.parse(text); // Parse response text
                            grid.clearAll(); // Clear the grid
                            grid.config.columns = [];
                            grid.refreshColumns();
                            if (
                                !resp.HasError &&
                                resp.Data != undefined &&
                                resp.Data.Columns != undefined &&
                                resp.Data.Columns.length > 0
                            ) {
                                grid.parse(resp.Data.Columns); // Populate grid with new data
                                for (var i in grid.config.columns) {
                                    grid.config.columns[i].sort = false; // Disable sorting for columns
                                    grid.adjustColumn(
                                        grid.config.columns[i].id,
                                        'all', // Adjust column width
                                    );
                                }
                                // Attach resize event to adjust columns on resize
                                grid.attachEvent('onResize', function (width, height) {
                                    for (var i in grid.config.columns) {
                                        grid.adjustColumn(grid.config.columns[i].id, 'all');
                                    }
                                });
                            }
                        },
                    });
                $$('toolbar1').show(); // Show the first toolbar
                $$('toolbar2').hide(); // Hide the second toolbar
            } else {
                grid2.show(); // Show the secondary grid
                grid.hide(); // Hide the main grid
                grid2.clearAll(); // Clear previous data
                string1 = string1 + '&Report=1'; // Append report flag to query
                webix
                    .ajax()
                    .headers({
                        'Content-type': 'application/json', // Set content type for AJAX request
                    })
                    .get(devConfig.geturlApi() + 'Financial/GetControlFiscal?' + string1, {
                        success: function (text, data, XmlHttpRequest) {
                            var resp = JSON.parse(text); // Parse response text
                            grid2.clearAll(); // Clear the secondary grid
                            grid2.config.columns = [];
                            grid2.refreshColumns();
                            if (
                                !resp.HasError &&
                                resp.Data != undefined &&
                                resp.Data.Columns != undefined &&
                                resp.Data.Columns.length > 0
                            ) {
                                grid2.parse(resp.Data.Columns); // Populate secondary grid with new data
                                for (var i in grid2.config.columns) {
                                    grid2.config.columns[i].sort = false; // Disable sorting for columns
                                    grid2.adjustColumn(
                                        grid2.config.columns[i].id,
                                        'all', // Adjust column width
                                    );
                                }
                                // Attach resize event to adjust columns on resize
                                grid2.attachEvent('onResize', function (width, height) {
                                    for (var i in grid2.config.columns) {
                                        grid2.adjustColumn(grid2.config.columns[i].id, 'all');
                                    }
                                });
                            }
                        },
                    });
                $$('toolbar2').show(); // Show the second toolbar
                $$('toolbar1').hide(); // Hide the first toolbar
            }
            $$('dColl').collapse(); // Collapse the details section
            filter = string1; // Update filter variable
            $$('filterPopup').hide(); // Hide the filter popup
        });

        // Event listener for exporting data
        this.on(this.app, 'export:filter', (filterData) => {
            flag = true; // Set export flag
            var firstfirst; // Variable for pagination
            if (filterData.first == 0) {
                firstfirst = filterData.first + 1; // Adjust for pagination
            } else {
                firstfirst = filterData.first; // Use first value
            }
            // Load data into the grid with pagination
            grid.load(url + '?start=' + firstfirst + '&count=' + (filterData.last + 1) + filter);
            // Attach event after data load
            grid.attachEvent('onAfterLoad', function () {
                if (flag) {
                    var size = grid.getPager().config.size; // Get page size
                    var page = grid.getPage(); // Get current page
                    var first = size * page; // Calculate first index
                    var last = first + size - 1; // Calculate last index
                    if ($$('Export1').getValue() == '1') {
                        // Check export type
                        console.log('Entro'); // Log entry
                        for (var j = 0; j < grid.config.columns.length; j++) {
                            if (grid.config.columns[j].exportType) {
                                delete grid.config.columns[j].format; // Remove format for export
                            }
                        }
                        this.app.callEvent('export:data', [
                            {
                                NameReport:
                                    _('Casino') +
                                    ($$('datatable').count() > 0 ? '' : _(' - No hay datos')) +
                                    ' - ' +
                                    new Date().toLocaleString(), // Set report name
                                TypeReport: 'Excel', // Set report type
                            },
                        ]);
                        // Export to Excel
                        webix.toExcel(grid, {
                            filter: function (obj) {
                                return (
                                    grid.getIndexById(obj.id) >= first && grid.getIndexById(obj.id) <= last // Filter data for export
                                );
                            },
                            filename:
                                'Virtualsoft - ' +
                                new Date()
                                    .toLocaleString('en-GB', { hour12: true })
                                    .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                    .replace(/[\/:]/g, '_')
                                    .toUpperCase() +
                                ' - ' +
                                ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                _('Casino'), // Set filename for export
                            ignore: { detailTittle: true, Type: true }, // Ignore specific fields
                            footer: false, // Do not include footer
                        });
                    } else {
                        if ($$('Export1').getValue() == '2') {
                            // Check for PDF export
                            this.app.callEvent('export:data', [
                                {
                                    NameReport:
                                        _('Casino') +
                                        ($$('datatable').count() > 0 ? '' : _(' - No hay datos')) +
                                        ' - ' +
                                        new Date().toLocaleString(), // Set report name
                                    TypeReport: 'PDF', // Set report type
                                },
                            ]);
                            // Export to PDF
                            webix.toPDF(grid, {
                                filter: function (obj) {
                                    return (
                                        grid.getIndexById(obj.id) >= first && grid.getIndexById(obj.id) <= last // Filter data for export
                                    );
                                },
                                filename:
                                    'Virtualsoft - ' +
                                    new Date()
                                        .toLocaleString('en-GB', {
                                            hour12: true,
                                        })
                                        .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                        .replace(/[\/:]/g, '_')
                                        .toUpperCase() +
                                    ' - ' +
                                    ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                    _('Casino'), // Set filename for export
                                autowidth: true, // Auto width for PDF
                                ignore: { detailTittle: true, Type: true }, // Ignore specific fields
                                footer: false, // Do not include footer
                            });
                        }
                    }
                    flag = false; // Reset export flag
                    $$('Export1').setValue(''); // Clear export selection
                }
            });
        });

        // Popup for user information
        var popupUser = webix.ui({
            view: 'window',
            id: 'popupUser', // Unique ID for the popup
            width: 700, // Width of the popup
            height: 800, // Height of the popup
            fullscreen: screen.width < 500 ? true : false, // Fullscreen for small screens
            head: {
                view: 'toolbar', // Toolbar for the popup header
                cols: [
                    { view: 'label', label: _('Información'), align: 'center' }, // Title label
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            $$('formUser').clear(); // Clear form data
                            this.getTopParentView().hide(); // Hide the popup
                        },
                    },
                ],
            },
            position: 'center', // Center position
            modal: true, // Modal popup
            body: {
                view: 'scrollview', // Scrollable body
                scroll: 'y',
                body: {
                    view: 'form', // Form for user details
                    id: 'formUser', // Unique ID for the form
                    elements: [
                        {
                            margin: 10,
                            cols: [
                                {
                                    rows: [
                                        {
                                            view: 'text',
                                            name: 'Id', // Field for user ID
                                            label: _("<span class='icon-id'></span> ID"),
                                            labelPosition: 'top',
                                            placeholder: _('Id'),
                                            invalidMessage: _('A ID is required'), // Validation message
                                            disabled: true, // Disable editing
                                        },
                                        {
                                            view: 'text',
                                            name: 'FirstName', // Field for first name
                                            label: _('Primer nombre'),
                                            labelPosition: 'top',
                                            placeholder: _('Primer nombre'),
                                            invalidMessage: _('A name is required'), // Validation message
                                        },
                                        {
                                            view: 'text',
                                            name: 'MiddleName', // Field for middle name
                                            label: _('Segundo Nombre'),
                                            labelPosition: 'top',
                                            placeholder: _('Segundo Nombre'),
                                            invalidMessage: _('A name is required'), // Validation message
                                        },
                                        {
                                            view: 'text',
                                            name: 'LastName', // Field for last name
                                            label: _('Apellido'),
                                            labelPosition: 'top',
                                            placeholder: _('Apellido'),
                                        },
                                        {
                                            view: 'text',
                                            name: 'SecondLastName', // Field for second last name
                                            label: _('Segundo Apellido'),
                                            labelPosition: 'top',
                                            placeholder: _('Segundo Apellido'),
                                        },
                                        {
                                            view: 'richselect',
                                            name: 'DocumentType', // Field for document type
                                            localId: 'DocumentType:combo',
                                            label: _('Tipo de Documento'),
                                            labelPosition: 'top',
                                            placeholder: _('Click para seleccionar '),
                                            options: [
                                                { id: 'C', value: _('DNI') },
                                                {
                                                    id: 'E',
                                                    value: _('Cedula de Extranjería'),
                                                },
                                                {
                                                    id: 'P',
                                                    value: _('Pasaporte'),
                                                },
                                            ],
                                            disabled: false, // Enable editing
                                        },
                                        {
                                            view: 'text',
                                            name: 'DocNumber', // Field for document number
                                            label: _('Numero de Documento'),
                                            labelPosition: 'top',
                                            placeholder: _('Numero de Documento'),
                                        },
                                        {
                                            view: 'richselect',
                                            name: 'Gender', // Field for gender
                                            localId: 'Gender:combo',
                                            label: _('Género'),
                                            labelPosition: 'top',
                                            placeholder: _('Click para seleccionar '),
                                            options: ['M', 'F'], // Gender options
                                            disabled: true, // Disable editing
                                        },
                                        {
                                            view: 'datepicker',
                                            name: 'BirthDate', // Field for birth date
                                            label: _('Cumpleaños'),
                                            labelPosition: 'top',
                                            placeholder: _('Click para seleccionar '),
                                            format: webix.Date.dateToStr('%d %M %Y'),
                                            disabled: false, // Enable editing
                                        },
                                        {
                                            view: 'text',
                                            name: 'Currency', // Field for currency
                                            label: "<span class='webix_icon mdi mdi-coin'></span>" + _('Moneda'),
                                            labelPosition: 'top',
                                            placeholder: _('Moneda'),
                                            disabled: true, // Disable editing
                                        },
                                        {
                                            view: 'text',
                                            name: 'Balance', // Field for balance
                                            label: _('Balance'),
                                            labelPosition: 'top',
                                            placeholder: _('Balance'),
                                            disabled: true, // Disable editing
                                        },
                                        {
                                            view: 'richselect',
                                            name: 'Estado', // Field for status
                                            label: _('Estado'),
                                            labelPosition: 'top',
                                            localId: 'Estado:combo',
                                            placeholder: _('Click para seleccionar '),
                                            options: [
                                                { id: 'A', value: _('Active') },
                                                {
                                                    id: 'I',
                                                    value: _('Inactive'),
                                                },
                                            ],
                                            disabled: true, // Disable editing
                                        },
                                        {
                                            view: 'richselect',
                                            name: 'StateSpecial', // Field for special status
                                            label: _('Estado Especial'),
                                            labelPosition: 'top',
                                            placeholder: _('Click para seleccionar '),
                                            options: [
                                                { id: 'A', value: _('Active') },
                                                {
                                                    id: 'I',
                                                    value: _('Inactive'),
                                                },
                                            ],
                                            disabled: true, // Disable editing
                                        },
                                        {
                                            view: 'text',
                                            name: 'IsLocked', // Field for locked status
                                            label: _('Está bloqueado?'),
                                            labelPosition: 'top',
                                            placeholder: _('Está bloqueado?'),
                                            disabled: true, // Disable editing
                                        },
                                    ],
                                },
                                {
                                    rows: [
                                        {
                                            view: 'richselect',
                                            name: 'CountryId', // Field for country
                                            id: 'country',
                                            localId: 'country:combo',
                                            label: _('País Residencia'),
                                            labelPosition: 'top',
                                            placeholder: _('Click para seleccionar '),
                                            options: [], // Country options
                                            disabled: true, // Disable editing
                                        },
                                        {
                                            view: 'richselect',
                                            name: 'RegionId', // Field for region
                                            id: 'ProvinceRegion',
                                            localId: 'ProvinceRegion:combo',
                                            label: _('Provincia/Región Residencia'),
                                            labelPosition: 'top',
                                            placeholder: _('Click para seleccionar '),
                                            options: [], // Region options
                                            disabled: true, // Disable editing
                                        },
                                        {
                                            view: 'richselect',
                                            name: 'CityId', // Field for city
                                            id: 'City',
                                            localId: 'cities:combo',
                                            label: _('Ciudad Residencia'),
                                            labelPosition: 'top',
                                            placeholder: _('Click para seleccionar '),
                                            options: [], // City options
                                            disabled: true, // Disable editing
                                        },
                                        {
                                            view: 'text',
                                            name: 'Address', // Field for address
                                            label: _('Dirección'),
                                            labelPosition: 'top',
                                            placeholder: _('Dirección'),
                                            disabled: false, // Enable editing
                                        },
                                        {
                                            view: 'text',
                                            name: 'ZipCode', // Field for zip code
                                            label: _('Código Zip'),
                                            labelPosition: 'top',
                                            placeholder: _('Código Zip'),
                                            disabled: true, // Disable editing
                                        },
                                        {
                                            view: 'text',
                                            name: 'Phone', // Field for phone number
                                            label: "<span class='icon-phone1'></span>" + _('Teléfono'),
                                            labelPosition: 'top',
                                            placeholder: _('Teléfono'),
                                            type: 'number', // Number type
                                            disabled: false, // Enable editing
                                        },
                                        {
                                            view: 'text',
                                            name: 'MobilePhone', // Field for mobile phone
                                            label: _('Celular'),
                                            labelPosition: 'top',
                                            placeholder: _('Celular'),
                                            type: 'number', // Number type
                                            disabled: false, // Enable editing
                                        },
                                        {
                                            view: 'richselect',
                                            name: 'CellStatus', // Field for cell status
                                            label: _('Estado Celular'),
                                            labelPosition: 'top',
                                            localId: 'Estado:combo',
                                            placeholder: _('Click para seleccionar '),
                                            options: [
                                                {
                                                    id: '0',
                                                    value: _('Verificado'),
                                                },
                                                {
                                                    id: '1',
                                                    value: _('Sin verificar'),
                                                },
                                            ],
                                            disabled: true, // Disable editing
                                        },
                                        {
                                            view: 'text',
                                            name: 'Email', // Field for email
                                            label: _('Email'),
                                            labelPosition: 'top',
                                            placeholder: _('Email'),
                                            disabled: false, // Enable editing
                                        },
                                        {
                                            view: 'text',
                                            name: 'CreatedLocalDate', // Field for registration date
                                            label: _('Fecha de registro'),
                                            labelPosition: 'top',
                                            placeholder: _('Fecha de registro'),
                                            disabled: true, // Disable editing
                                        },
                                        {
                                            view: 'text',
                                            name: 'LastLoginLocalDate', // Field for last login date
                                            label: _('Fecha de ultimo login'),
                                            labelPosition: 'top',
                                            placeholder: _('Fecha de ultimo login'),
                                            disabled: true, // Disable editing
                                        },
                                        {
                                            view: 'text',
                                            name: 'LastIPaddress', // Field for last IP address
                                            label: _('Última dirección IP'),
                                            labelPosition: 'top',
                                            placeholder: _('Última dirección IP'),
                                            disabled: true, // Disable editing
                                        },
                                        {
                                            view: 'button',
                                            value: _('Ir al usuario'), // Button to go to user
                                            type: 'form',
                                            click: function (obj) {
                                                var values = $$('formUser').getValues(); // Get form values
                                                window.open(
                                                    '/#!/top/customers?user=' + values.Id + '/information',
                                                    '_blank', // Open user information in new tab
                                                );
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                    ],
                },
            },
        });

        // Event listener for opening user popup
        this.on(this.app, 'popupUserIframe', (id) => {
            webix
                .ui({
                    view: 'window',
                    id: 'popupUserIframe', // Unique ID for the iframe popup
                    head: {
                        view: 'toolbar', // Toolbar for the iframe header
                        cols: [
                            {
                                view: 'label',
                                label: _('Información'), // Title label
                                align: 'center',
                            },
                            {
                                view: 'icon',
                                icon: 'wxi-close', // Close icon
                                click: function () {
                                    this.getTopParentView().hide(); // Hide the popup
                                },
                            },
                        ],
                    },
                    position: 'center', // Center position
                    modal: true, // Modal popup
                    body: {
                        view: 'iframe', // Iframe for displaying user information
                        id: 'frame-body',
                        src: '/#!/top/customers?user=' + id + '/information', // Source URL for iframe
                    },
                })
                .show(); // Show the iframe popup
            $$('popupUserIframe').setPosition(15, 15); // Set position of the iframe
            $$('popupUserIframe').$setSize(
                $(window).width() - 30,
                $(window).height() - 30, // Set size of the iframe
            );
        });

        // Event listener for updating form data
        this.on(this.app, 'form:update', (id) => {
            webix.ajax().get(
                devConfig.geturlApi() + 'Client/GetClientById',
                'id=' + id, // API call to get client data by ID
                {
                    error: function (text, data, XmlHttpRequest) {
                        webix.message('Error! '); // Error handling
                    },
                    success: function (text, data, XmlHttpRequest) {
                        text = JSON.parse(text); // Parse response text
                        vthis.app.callEvent('customer:updatedata', [
                            text[0], // Trigger event with updated data
                        ]);
                        $$('country').setValue(text[0].CountryId); // Set country value
                        webix.delay(
                            function () {
                                $$('ProvinceRegion').setValue(
                                    text[0].RegionId, // Set region value
                                );
                                webix.delay(
                                    function () {
                                        $$('City').setValue(text[0].CityId); // Set city value
                                    },
                                    '',
                                    '',
                                    1000,
                                );
                            },
                            '',
                            '',
                            1000,
                        );
                    },
                },
            );
        });

        // Event listener for updating user data in the form
        this.on(this.app, 'customer:updatedata', (person) => {
            $$('formUser').setValues(person); // Set form values with updated data
        });

        // Event listener for country selection
        $$('country').attachEvent('onItemClick', function (id, e) {
            webix
                .ajax()
                .headers({
                    'Content-type': 'application/json', // Set content type for AJAX request
                })
                .post(devConfig.geturlApi() + 'Agent/GetAgentCountries', '', {
                    error: function (text, data, XmlHttpRequest) {
                        webix.message('Error! '); // Error handling
                    },
                    success: function (text, data, XmlHttpRequest) {
                        var data = JSON.parse(text.replace(/"Id"/g, '"id"').replace(/"Name"/g, '"value"')); // Parse response and format data
                        var optionsCountries = $$('country').getList(); // Get country options list
                        optionsCountries.clearAll(); // Clear existing options
                        optionsCountries.parse(data.Data); // Populate with new data
                    },
                });
        });

        // Event listener for country change
        $$('country').attachEvent('onChange', function (newv, oldv) {
            var optionscountries = this.getList().getItem(newv); // Get selected country
            var optionsProvinceRegions = $$('ProvinceRegion').getList(); // Get province/region options list
            if (optionscountries != undefined) {
                optionsProvinceRegions.clearAll(); // Clear existing options
                optionsProvinceRegions.parse(optionscountries.departments); // Populate with new data
            }
        });

        // Event listener for province/region change
        $$('ProvinceRegion').attachEvent('onChange', function (newv, oldv) {
            var optionsProvinceRegions = this.getList().getItem(newv); // Get selected province/region
            var optionsCity = $$('City').getList(); // Get city options list
            optionsCity.clearAll(); // Clear existing options
            if (optionsProvinceRegions != undefined) {
                optionsCity.parse(optionsProvinceRegions.cities); // Populate with new data
            }
        });
    }
}

// FILE DOCUMENTED
